import {Component, OnInit} from '@angular/core';
import {DashboardHttpService} from '../../../services/http-services/dashboard/dashboard-http.service';
import {ReservationsHttpService} from "../../../services/http-services/reservations/reservations-http.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'gr-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
  dashboardData: any;
  urlParams: {date: string | null} = {date: '2025-04'};

  constructor(
    private dashboardService: DashboardHttpService,
    private reservationsHttpService: ReservationsHttpService,
    private toastrService: ToastrService,
    ) {
  }

  ngOnInit(): void {
    this.getDashboardData();
  }

  getDashboardData(): void {
    this.dashboardService.getDashboardData().then(res => {
      this.dashboardData = res.data;
    });
  }

  exportData(): void {
    this.reservationsHttpService.exportDashboardData(this.urlParams).subscribe((response: Blob) => {
      console.log(response);
      if (response.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const blobUrl = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `Rezervacija${this.urlParams.date}.xlsx`;
        link.click();
        URL.revokeObjectURL(blobUrl);
      } else {
        console.error('The fetched file is not an Excel file');
      }
    });
  }

}
